import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { FormComponent } from './pages/form/form.component';
import { LandingComponent } from './pages/landing/landing.component';
import { WelcomeAuthenticateComponent } from './pages/welcome-authenticate/welcome-authenticate.component';
import { WelcomeConfigureComponent } from './pages/welcome-configure/welcome-configure.component';
import { WelcomeWizardComponent } from './pages/welcome-wizard/welcome-wizard.component';

const routes: Routes = [
	{ path: '', component: LandingComponent, canActivate: [] },
	{ path: 'welcome', component: WelcomeWizardComponent, canActivate: [] },
	{ path: 'welcome/authenticate', component: WelcomeAuthenticateComponent, canActivate: [] },
	{ path: 'welcome/configure', component: WelcomeConfigureComponent, canActivate: [] },
	{ path: 'form', component: FormComponent, canActivate: [] },
];

@NgModule({
	imports: [RouterModule.forRoot(routes)],
	exports: [RouterModule]
})
export class AppRoutingModule { }
